import { useState } from "react";
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, MenuItem,} from "@mui/material";
import { toast } from "react-toastify";
import { createEntity, deleteCommentEntities, deleteParams, filterEntities,} from "../../apis/apiService";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";
import "animate.css";
import { RiDeleteBin5Line } from "react-icons/ri";
import { useFetchTaskAllocationQuery } from "../../slice/logdetailSlice";
import { format } from "date-fns";
import { BtnLoader } from "./Loader";



export const CommonDeleteUsers = ({
  url,
  id,
  name,
  refetchList,
  handleListClose,
  statusName,
  user_id,
  refetchListTwo,
}) => {
  const [open, setOpen] = useState(false);
  const login_user = useSelector((state) => state.selectOptions?.loginUserName);
  //console.log("login_user in pproject:", login_user);
  const { role: login_user_role } = login_user;
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const handleDelete = async () => {
    // //console.log(`View task: ${selectedTask}`);
    try {
      const response = await deleteParams(url, id, {
        user_id: user_id,
      });

      refetchList();
      if (refetchListTwo) {
        refetchListTwo();
      }
      toast.success(response.message);
    } 
    catch (err) {
      console.error("Error deleting user:", err);
      toast.error(err.message);
    } 
    finally {
      handleListClose();
    }
  };

  return (
    <>
      {/* Delete Button */}
      {login_user_role !== "CLIENT" && (
        <MenuItem onClick={handleOpen}>
          <RiDeleteBin5Line className="tex-tgba-red me-2" />
          Delete {name}
        </MenuItem>
      )}

      {/* Delete Confirmation Dialog */}
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Confirm Deletion</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete this {name} "
            <strong>{statusName}</strong>
            "?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>No</Button>
          <Button onClick={handleDelete} color="error">
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export const CommonDeleteDialog = ({
  url,
  id,
  name,
  refetchList,
  handleListClose, // Passed as a prop to close the delete icon popup
  statusName,
  deleteUser,
  logHours,
}) => {
  const login_user = useSelector((state) => state.selectOptions?.loginUserName);
  const { role: login_user_role } = login_user;
  // console.log("log_hours :", logHours);

  const hasLogHours = name === "Task" && logHours !== "00:00";
  // Function to show SweetAlert for deletion confirmation
  const showDeleteConfirmationPopup = (name, statusName) => {
    handleListClose();
    Swal.fire({
      title: `Confirm Deletion`,
      html: `
      Are you sure you want to delete this ${name} "<strong>${statusName}</strong>" ?
      ${
        hasLogHours
          ? `<br/><br/><strong>Note:</strong> This task has <strong>${logHours}</strong> hours of logs. Deleting this task will also remove these logs.`
          : ""
      }
    `,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Delete it!",
      showCloseButton: true,
      cancelButtonText: "Cancel",
      customClass: {
        popup:
          "animate__animated animate__fadeInLeft animate__faster custom-swal-popup",
        title: "custom-swal-title",
        htmlContainer: "custom-swal-html",
        icon: "custom-swal-icon",
        confirmButton: "swal-confirm-btn",
        cancelButton: "swal-cancel-btn",
      },
      showClass: {
        popup: "animate__animated animate__fadeInLeft ", // Fade-in animation
      },
      hideClass: {
        popup: "animate__animated animate__fadeOutRight", // Fade-out animation
      },
      preConfirm: async () => {
        try {
          const response = await deleteCommentEntities(url, id); // Assuming this is your API call for deletion
          refetchList();
          Swal.fire({
            title: "Deleted!",
            text: response.message,
            icon: "success",
            confirmButtonText: "OK",
            customClass: {
              popup: " custom-swal-popup",
              confirmButton: "swal-confirm-btn",
              title: "custom-swal-title",
              text: "custom-swal-html",
              icon: "custom-swal-icon",
              cancelButton: "swal-cancel-btn",
            },
          }); // Success message after deletion
          handleListClose(); // Close the popup after deletion
        } 
        catch (error) {
          // console.error(`Failed to delete ${name}:`, error);
          Swal.fire("Error", error.message, "error"); // Error message if deletion fails
          handleListClose(); // Close the popup even on error
        }
      },
    });
  };

  return (
    <>
      {/* Delete Button */}
      {login_user_role !== "CLIENT" && (
        <MenuItem onClick={() => showDeleteConfirmationPopup(name, statusName)}>
          <RiDeleteBin5Line className="tex-tgba-red me-2" />
          Delete {name}
        </MenuItem>
      )}
    </>
  );
};

export default CommonDeleteDialog;

export const CommonDeactivate = ({
  selectedUser,
  refetchList,
  handleClosePopup,
  openPopup,
  setOpenPopup,
  setSelectedUser,
  deactivatePath,
}) => {
  // const [openPopup, setOpenPopup] = useState(false);
  // const [selectedUser, setSelectedUser] = useState(null);
  const handleConfirmAction = async () => {
    const { user_id } = selectedUser;
    const requestedData = {
      user_id: user_id,
      status: selectedUser?.is_active === 1 ? false : true,
    };
    try {
      const response = await createEntity(deactivatePath, requestedData);
      if (response) {
        toast.success(response.message);
        refetchList();
        setOpenPopup(false);
        setSelectedUser(null);
      } 
      else {
        toast.error(response.message);
        setOpenPopup(false);
        setSelectedUser(null);
      }
    } 
    catch (error) {
      toast.error(error.message);
      setOpenPopup(false);
      setSelectedUser(null);
    }
    // console.log("params_user_value :", user_id, user_name);
  };

  const handleCancel = () => {
    setOpenPopup(false);
    setSelectedUser(null);
  };

  return (
    <>
      <Dialog open={openPopup} onClose={handleClosePopup}>
        <DialogTitle>Confirm Action</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to{" "}
            {selectedUser?.is_active ? "deactivate" : "activate"}{" "}
            <strong>{selectedUser?.user_name}</strong>?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancel} color="primary">
            Cancel
          </Button>
          <Button
            onClick={handleConfirmAction}
            color="error"
            // variant="contained"
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export const CommonDelete = ({
  open,
  handleClose,
  selectedTask,
  refetchList,
  refetchListTwo,
  date,
  source,
  isDraft,
  full_task_allocation_data_refetch,
  task_allocation_refetch,
  name,
  publish,
  isButtonDisabled, 
  selectionRange,
  task_allocation_data,
  // setPublish,
}) => {
  const [loading, setLoading] = useState(false);
  
 

  // const handleDeleteConfirmed = async () => {
  //   // console.log(`Deleting task: date=${date}, source=${source}, isDraft=${isDraft}`);
  //   setLoading(true);

  //   try {
  //         let finalSource = source;
  //   let finalIsDraft = isDraft;
  //     if (isButtonDisabled) {
  //       // const response = await filterEntities(
  //       //         "task-allocation/view",
  //       //         requestedData
  //       //       );
  //     const viewResponse = await filterEntities("task-allocation/view", {
  //       date: format(selectionRange.startDate, "dd-MM-yyyy"),
  //     });

  //     if (viewResponse?.meta) {
  //       finalSource = viewResponse.meta.source || "ASSIGN_TASK";
  //       finalIsDraft = viewResponse.meta.is_draft;
  //     }
  //   }
  //   const payload = {
  //     isDraft: finalIsDraft,
  //     date,
  //     source: finalSource,
  //   };

  //     const response = await deleteParams(
  //     "task-allocation/delete",
  //     selectedTask?.id,
  //     payload
  //   );

  //     // setPublish?.(false);
  //     if(response){
  //       // if(task_allocation_refetch){
  //       if(!publish){
  //         task_allocation_refetch();
  //         full_task_allocation_data_refetch()
  //       }
  //         // task_allocation_refetch();
  //         // full_task_allocation_data_refetch()
  //       // }
  //       if(source=="PUBLISH" || source=="DUPLICATE"){
  //             refetchList();
  //       refetchListTwo();
  //       }
    
  //     }

  //     // ✅ Safe refetch
  //     // if (typeof refetchList === "function") {
  //     //   try {
  //     //     await 
  //     //   } catch (err) {
  //     //     console.warn("refetchList not ready:", err.message);
  //     //   }
  //     // }

  //     // if (typeof refetchListTwo === "function") {
  //     //   try {
  //     //     await 
  //     //   } catch (err) {
  //     //     console.warn("refetchListTwo not ready:", err.message);
  //     //   }
  //     // }

  //     toast.success(response.message);
  //   } catch (err) {
  //     console.error("Delete error:", err);
  //   } finally {
  //     handleClose();
  //     setLoading(false);
  //   }
  // };


    const handleDeleteConfirmed = async () => {
    setLoading(true);

    try {
      let finalSource = source;
      let finalIsDraft = isDraft;

      // ✅ Check if current visible button is "Assign Tasks"
      const isAssignTasksMode =
        !publish && task_allocation_data?.meta?.source !== "DUPLICATE";

        if(finalSource==="DUPLICATE"){
          finalIsDraft=true;
        }

          if (isButtonDisabled) {
      finalIsDraft = false;
    }

      // ✅ If "Assign Tasks" mode, call the View API to fetch meta
      if (isAssignTasksMode) {
        
        const viewResponse = await filterEntities("task-allocation/view", {
          date: format(selectionRange.startDate, "dd-MM-yyyy"),
        });
        // console.log("draft value",viewResponse.meta.is_draft);

        if (viewResponse?.meta) {
          finalSource = viewResponse.meta.source || "ASSIGN_TASK";
          finalIsDraft = viewResponse.meta.is_draft;
        }
      }

      // ✅ Build payload
      const payload = {
        isDraft: finalIsDraft,
        date,
        source: finalSource,
      };

      // ✅ Call delete API
      const response = await deleteParams( "task-allocation/delete", selectedTask?.id, payload );
      if (response) {
        // Refresh necessary data
        if (!publish) {
          task_allocation_refetch();
          full_task_allocation_data_refetch();
        }

        if (source === "PUBLISH" || source === "DUPLICATE") {
          refetchList();
          refetchListTwo();
        }

        toast.success(response.message);
      }
    }
    catch (err) {
      console.error("Delete error:", err);
    } 
    finally {
      handleClose();
      setLoading(false);
    }
  };
  
  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Confirm Deletion</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Are you sure you want to delete this {name}{" "}
          <strong>"{selectedTask?.name}"</strong> from the{" "}
          {selectedTask?.department} department?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button disabled={loading} onClick={handleClose}>
          No
        </Button>
       <Button
            disabled={loading}
            onClick={handleDeleteConfirmed}
            color="error"
            variant="contained"
          >
            {loading ? <BtnLoader /> : "Yes"}
          </Button>
                </DialogActions>
              </Dialog>
            );
          };


export const CommonDeleteDrafts = ({
  open,
  handleClose,
  refetchList,
  date,
  tableRefetch,
  task_allocation_draft_id,
  calendar_date,
  refetchlistTwo,
  onRefresh
}) => {
  const [loading, setLoading] = useState(false);
  const { refetch: task_allocation_refetch } = useFetchTaskAllocationQuery(
    {
      date: calendar_date,
    },
    { skip: !calendar_date }
  );
  const handleDeleteConfirmed = async () => {
    // console.log("Deleting_task ID:", selectedTask);
    setLoading(true);
    // const requestedData = {
    //   date: date,
    // };
    try {
      const response = await deleteCommentEntities( "task-allocation/drafts/discard", task_allocation_draft_id);
      if (response) {
        refetchList();
        toast.success(response.message);
        refetchlistTwo();
        task_allocation_refetch();
        onRefresh?.();
      }
    } 
    catch (err) {
      toast.error(err.message);
    } 
    finally {
      handleClose();
      setLoading(false);
    }
  };

  return (
    <div>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Confirm Deletion</DialogTitle>

        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete this <strong>Draft</strong>?
          </DialogContentText>

          <DialogContentText
            sx={{ mt: 2, color: "warning.main", fontWeight: 500 }}
          >
            ⚠️ Note: Deleting these will permanently remove all draft records
            for the selected date (<strong>{date}</strong>).
          </DialogContentText>
        </DialogContent>

        <DialogActions sx={{ gap: 1, pr: 3, pb: 2 }}>
          <Button
            disabled={loading}
            onClick={handleClose}
            variant="outlined"
            sx={{
              borderRadius: "6px",
              borderColor: "#ccc",
              color: "#1976d2",
              textTransform: "none",
              px: 2.5,
              "&:hover": {
                borderColor: "#9ac6f3ff",
                backgroundColor: "rgba(25, 118, 210, 0.04)",
              },
            }}
          >
            No
          </Button>
          <Button
            disabled={loading}
            onClick={handleDeleteConfirmed}
            variant="outlined"
            color="error"
            sx={{
              borderRadius: "6px",
              borderColor: "#ccc",
              textTransform: "none",
              px: 2.5,
              "&:hover": {
                borderColor: "#f2aaaaff",
                backgroundColor: "rgba(211, 47, 47, 0.04)",
              },
            }}
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};
